import {useQuery} from '@tanstack/react-query'
import {getGoalForOwner} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useFetchGoalForOwnerV3 = (goalId?: string | null) => {
    return useQuery({
        queryKey: [QUERY_KEYS.selectedGoal, goalId],
        queryFn: () => getGoalForOwner({goalId: goalId!}),
        enabled: !!goalId
    })
}
